import { render, staticRenderFns } from "./patientItem.vue?vue&type=template&id=808734ee&scoped=true&"
import script from "./patientItem.vue?vue&type=script&lang=js&"
export * from "./patientItem.vue?vue&type=script&lang=js&"
import style0 from "./patientItem.vue?vue&type=style&index=0&id=808734ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808734ee",
  null
  
)

export default component.exports